import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AwbDocument, DocumentData, GeneralData } from '../../document.interface';
import { helper } from 'src/environments/helper';
import { DashboardService } from '../../dashboard.service';
import { MatDialog } from '@angular/material/dialog';
import { PermissionsService } from 'src/app/services/permissions.service';
import { AddAwbComponent } from './add-awb/add-awb.component';
import { AwbService } from 'src/app/components/awb/awb.service';
import { AppFilesService } from 'src/app/services/app-files.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-generare-awb',
    templateUrl: './generare-awb.component.html',
    styleUrls: ['./generare-awb.component.scss']
})
export class GenerareAwbComponent {
    @Input() docData!: DocumentData;
    @Input() generalData!: GeneralData[];
    @Output() docChanged: EventEmitter<void> = new EventEmitter();
    @Output() isLoading = new EventEmitter<boolean>();

    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;

    helper = helper;

    constructor(
        public dashboardService: DashboardService,
        private awbService: AwbService,
        private appFilesService: AppFilesService,
        public dialog: MatDialog,
        public permissionsService: PermissionsService,
    ) { }

    openAddAWBDialog(): void {
        const dialogRef = this.dialog.open(AddAwbComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                generalData: this.generalData,
                docData: this.docData,
            },
        });

        dialogRef.afterClosed().subscribe(({ success }) => {
            if (success) {
                this.docChanged.emit();
            }
        });
    }

    openEditAWBDialog(awb: AwbDocument) {
        const dialogRef = this.dialog.open(AddAwbComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                generalData: this.generalData,
                docData: this.docData,
                awbData: awb,
            },
        });

        dialogRef.afterClosed().subscribe(({ success }) => {
            if (success) {
                this.docChanged.emit();
            }
        });
    }

    openViewAWBDialog(awb: AwbDocument) {
        this.dialog.open(AddAwbComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                generalData: this.generalData,
                docData: this.docData,
                awbData: awb,
                onlyView: true,
            },
        });
    }

    downloadAwb(id: number, identificator: string) {
        this.isLoading.emit(true);
        let fullPath = this.awbService.downloadPDFAwbUrl + id;

        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading.emit(false);
            })
            .catch(err => {
                console.error('Print error: ', err);
                this.isLoading.emit(false);
            })
    }

    duplicateAwb(id: number) {
        Swal.fire({
            title: helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Veți duplica înregistrarea curentă!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.dashboardService.duplicateAWB(id).subscribe({
                    next: () => {
                        Swal.fire({
                            title: 'Duplicată!',
                            text: 'Înregistrare duplicată cu succes!',
                            icon: 'success',
                            confirmButtonText: helper.swalTextConfig.buttonLabels.ok,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.docChanged.emit();
                            }
                        });
                    },
                    error: (err: any) => {
                        Swal.fire({
                            title: helper.dialogConfig.headers.errorAtentie,
                            text: err.error.errors.message[0],
                            icon: 'error',
                            confirmButtonText: helper.dialogConfig.buttonLabels.close,
                        })
                    }
                });
            }
        });
    }

    deleteAwb(id: number) {
        Swal.fire({
            title: helper.swalTextConfig.commonTitles.areYouSure,
            text: helper.swalTextConfig.generalMessages.delete,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.awbService.deleteAwb(id).subscribe({
                    next: () => {
                        Swal.fire({
                            title: this.helper.swalTextConfig.headers.deleted,
                            text: 'Înregistrare ștearsă cu succes.',
                            icon: 'success',
                            confirmButtonText: helper.swalTextConfig.buttonLabels.ok,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.docChanged.emit();
                            }
                        });
                    },
                    error: (err: any) => {
                        Swal.fire({
                            title: helper.dialogConfig.headers.errorAtentie,
                            text: err.error.errors.message[0],
                            icon: 'error',
                            confirmButtonText: helper.dialogConfig.buttonLabels.close,
                        })
                    }
                });
            }
        });
    }

    deleteAwbPosta(id: number) {
        Swal.fire({
            title: helper.swalTextConfig.commonTitles.areYouSure,
            text: helper.swalTextConfig.generalMessages.delete,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.awbService.deleteAwbPosta(id).subscribe({
                    next: () => {
                        Swal.fire({
                            title: this.helper.swalTextConfig.headers.deleted,
                            text: 'Înregistrare ștearsă cu succes.',
                            icon: 'success',
                            confirmButtonText: helper.swalTextConfig.buttonLabels.ok,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.docChanged.emit();
                            }
                        });
                    },
                    error: (err: any) => {
                        Swal.fire({
                            title: helper.dialogConfig.headers.errorAtentie,
                            text: err.error.errors.message[0],
                            icon: 'error',
                            confirmButtonText: helper.dialogConfig.buttonLabels.close,
                        })
                    }
                });
            }
        });
    }
}
